/* Sign-in screen — thin view shell (FE-PR-20). Logic: useSignInScreen.ts */

import { CustomerFormFieldBoundary } from '../../shared/ui/FormField.js';
import { useSignInScreen, type UseSignInScreenInput } from './hooks/useSignInScreen.js';
import { SignInScreenView } from './components/SignInScreenView.js';

export type SignInScreenProps = UseSignInScreenInput;

export function SignInScreen(props: SignInScreenProps): JSX.Element {
  const screen = useSignInScreen(props);

  // Defense in depth: never paint SignInScreenView while guest-auth gate blocks
  // (hydration wait or signed-in redirect on dedicated auth routes).
  if (screen.guestAuthBlocked) {
    return (
      <p
        className="p-4 text-[length:var(--vcl-type-body-sm-size)] text-[var(--color-on-surface-muted)]"
        role="status"
        data-testid="sign-in-guest-auth-blocked"
      >
        {screen.t('account.sessionHydrating')}
      </p>
    );
  }

  return (
    <CustomerFormFieldBoundary>
      <SignInScreenView {...screen} />
    </CustomerFormFieldBoundary>
  );
}
